import request from '@/utils/request';


let server = {
  reviewList: '/goods_comments', // 游客可访问的评论列表
  commonPage: '/goods_comments', // 游客可访问的评论列表
  releaseComments: '/goods_comments', // 发布评论
  myListComments: '/goods_comments', // 评论列表
  deleteComments: '/goods_comments', // 删除评论
};


//  游客可访问的评论列表
export function reviewList(goodsId) {
	return request({
    	url: server.reviewList + '/' + goodsId,
	    method: 'get',
  	})
}
//  游客可访问的评论列表分页
export function commonPage(goodsId,page) {
	return request({
    	url: server.commonPage + '/' + goodsId + '?page=' + page,
	    method: 'get',
  	})
}


//  发布评论
export function releaseComments( params , orderId) {
	return request({
    	url: server.releaseComments + '/' + orderId,
	    method: 'post',
      data:params
  	})
}


//  评论列表
export function myListComments() {
	return request({
    	url: server.myListComments,
	    method: 'get',
  	})
}


//  删除评论
export function deleteComments(id) {
	return request({
    	url: server.deleteComments + '/' +　id,
	    method: 'delete',
  	})
}









// WEBPACK FOOTER //
// ./src/api/comment.js